export default __webpack_public_path__ + "static/media/sjic.e17c26b5.png";